module.exports = __webpack_public_path__ + "img/support.6459567a.svg";